import React from 'react';
import styled from 'styled-components';
import Title from './Title';
import FormContainer from 'containers/FormContainer';
import Showroom from './Showroom';
import Map from './Map';

const Wrapper = styled.div`
  width: 100%;
`;

const Contact = ({color}) => {
  return (
    <Wrapper>
      <Title color={color}/>
      <FormContainer/>
      <Showroom/>
      <Map/>
    </Wrapper>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.js